import React from 'react';
import publications from './publications.json';
import updates from './updates.json';
import Updates from './Updates';
import MusicPlayer from './MusicPlayer';
import './App.css';

const scholar = 'https://scholar.google.com/citations?user=gg-AUEsAAAAJ&hl=en';

function Authors({ children }) {
  return children.split(/(Sumin Hong\*?)/).map((part, index) =>
    part.startsWith('Sumin Hong') ? <strong key={index}>{part}</strong> : part
  );
}

function Publication({ publication }) {
  const { title, venue, authors, image, url, paper, preprint, note, website, blendBackground, comingSoon } = publication;
  return (
    <article className="publication">
      <div className={`publication-image${image ? '' : ' placeholder'}${blendBackground ? ' blend-background' : ''}`} aria-hidden={!image}>
        {image && <img src={image} alt={`Research overview: ${title}`} loading="lazy" />}
      </div>
      <div className="publication-details">
        <h3>{title}</h3>
        <p className="venue">{venue}</p>
        {authors && <p className="authors"><Authors>{authors}</Authors></p>}
        {note && <p className="contribution">{note}</p>}
        <div className="publication-links">
          {preprint ? <a className="paper-link" href={preprint}>Preprint</a> : comingSoon ? <span className="coming-soon">coming soon!</span> : paper ? <a className="paper-link" href={paper}>Paper</a> :
            <span className="paper-link unavailable" aria-label="Paper link not yet available" title="Paper link not yet available">Paper</span>}
          {url && <a className="paper-link" href={url}>DOI</a>}
          {website && <a className="paper-link" href={website}>Website</a>}
        </div>
      </div>
    </article>
  );
}

function App() {
  return (
    <>
      <a className="skip-link" href="#main">Skip to content</a>
      <div className="page">
        <aside className="profile" aria-label="Sumin Hong's profile">
          <img className="profile-photo" src="design/profile.jpg" width="3099" height="2324" alt="Sumin Hong wearing blue headphones, in a mirror" />
          <div className="profile-links">
            <a className="email" href="mailto:shong6@nd.edu">shong6@nd.edu</a>
            {/* <a href="screen/cv-2024.pdf">curriculum vitæ</a> */}
            <a href="https://x.com/suminhong_">X</a>
            <a href="https://github.com/dripdropdr">github</a>
            <a href="https://www.linkedin.com/in/sumin-hong-b43931221/">linkedin</a>
            <MusicPlayer />
          </div>
          <h2 className="miscellaneous">miscellaneous</h2>
        </aside>

        <main id="main">
          <section className="introduction" aria-labelledby="greeting">
            <h1 id="greeting">Hellooooo I am Sumin,</h1>
            <p className="position">third year PhD student, in <a href="https://cse.nd.edu/">CSE</a> at <a href="https://www.nd.edu/">University of Notre Dame</a>, advised by <a href="https://toby.li/">Prof. Toby Jia-Jun Li.</a></p>
            <p className="research-statement">Modalities are how we take in the world and how we push meaning back out into it. I study three dimensions — (1) how sensory signals carry traces of human cognition, (2) how they become the medium through which meaning is shaped and expressed, and (3) how AI models represent and learn from sensory information. My work explores these questions at the intersection of HCI, AI, and cognitive science.</p>
            <p className="personal-note">I love real things!</p>
          </section>

          <Updates entries={updates} />

          <section className="publications" id="publications" aria-labelledby="publications-heading">
            <div className="section-heading"><h2 id="publications-heading">Publications</h2><a href={scholar}>google scholar</a></div>
            <div className="publication-list">{publications.map(publication => <Publication key={publication.title} publication={publication} />)}</div>
          </section>
        </main>
      </div>
    </>
  );
}

export default App;
